import React from 'react';

export type DividerProps = {
  text?: React.ReactNode;
  align?: 'right' | 'center' | 'left';
  rootClass?: string;
  leftClass?: string;
  rightClass?: string;
};

const alignClassMap = {
  right: 'text-right',
  center: 'text-center',
  left: '',
};

export const Divider: React.FC<DividerProps> = ({
  text,
  children,
  align,
  rootClass = '',
  leftClass = '',
  rightClass = '',
}) => {
  const textAlignClass = alignClassMap[align];

  return (
    <div className={`flex items-center ${rootClass}`}>
      <div className={`border-t border-gray-300 flex-grow ${leftClass}`}></div>
      <div className={`px-4 ${textAlignClass}`}>{text || children}</div>
      <div className={`border-t border-gray-300 flex-grow ${rightClass}`}></div>
    </div>
  );
};
